import { useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "./auth";

/**
 * Live ✊ buyer count for a product. Starts from product.bhega_count and refetches
 * GET /products/{id} (city-scoped) whenever a `bhega:changed` event fires for it.
 */
export default function useLiveCount(product) {
  const { city } = useAuth();
  const id = product?.id;
  const initial = product?.bhega_count || 0;
  const [count, setCount] = useState(initial);

  useEffect(() => { setCount(initial); }, [initial]);

  useEffect(() => {
    if (!id) return undefined;
    let active = true;
    const onChange = async (ev) => {
      const pid = ev?.detail?.productId;
      if (pid && pid !== id) return;
      try {
        const r = await api.get(`/products/${id}`, { params: city ? { city } : {} });
        if (active && r.data?.bhega_count != null) setCount(r.data.bhega_count);
      } catch (_) { /* noop */ }
    };
    window.addEventListener("bhega:changed", onChange);
    return () => { active = false; window.removeEventListener("bhega:changed", onChange); };
  }, [id, city]);

  return count;
}
